module.exports = __webpack_public_path__ + "img/DSC06307.87109f6b.jpg";